import React, { useEffect, useState, useRef } from "react";
import { Link, useNavigate, useParams, useLocation } from "react-router-dom";
import { ReactSession } from "../../../../lib/secure_reactsession";
import {
    removeItemFromArray,
    showToast,
    shuffle,
} from "../../../../lib/helpers";
import { saveSurveyResultQuestion } from "../../../../services/test_result";

import SurveyIntroduction from "./survey_test_introduction";

import TaskNotCompleted from "../../elements/TaskNotCompleted";
import GlobalQuestion from "../../global-question";

export default function SurveyTest({
    test,
    result,
    questionCallback,
    callback,
    questionType,
    timeSpent,
}) {
    const location = useLocation();
    const [isActiveQuestion, setActiveQuestion] = useState(null);
    const [totalQuestion, setTotalQuestion] = useState(0);
    const [QuestionArrayList, setQuestionArrayList] = useState([]);
    const [questionLoading, setQuestionLoading] = useState(false);
    const [questionArray, setQuestionArray] = useState([]);
    const [questionTimeSpend, setQuestionTimeSpend] = useState(0);
    const [initialScreen, setInitialScreen] = useState(true);
    const [questionsScreen, setQuestionsScreen] = useState(false);
    const [rankingOptions, setRankingOptions] = useState([]);
    const [formValues, setFormValues] = useState({});
    const [options, setOptions] = useState([]);
    const isActiveQuestionId = useRef(null);
    const isSkipped = useRef(0);
    const logicalySkipped = useRef(0);
    const isTyping = useRef(false);
    const [logicAdded, setLogicAdded] = useState(false);
    const nextButtonActive = useRef(false);
    const likertAttemptedSubQuestion = useRef(0);
    const otherOptionSelected = useRef(false);
    const [isNoneOfTheAboveSelected, setIsNoneOfTheAboveSelected] = useState(false);
    const isOptional = useRef(false);
    const [skippedCount, setSkippedCount] = useState(0);

    useEffect(() => {
        let Questions = [];

        if (questionType === "Survey") {
            if (test && test.survey_question.length) {
                setActiveQuestion(1);
                setTotalQuestion(test && test.survey_question.length);

                test &&
                    test.survey_question.forEach((items) => {
                        Questions.push({
                            data: items,
                            questionData: JSON.parse(items.questions),
                        });
                        if (JSON.parse(items.questions)["is_logic"] == 1) {
                            setLogicAdded(true);
                        }
                    });

                setQuestionArrayList(Questions);
                // Set the initial active question ID
                if (Questions.length > 0) {
                    isActiveQuestionId.current = Questions[0].data.id;
                }
            }
        }

        window.scrollTo(0, 0);

        function tickTime() {
            setQuestionTimeSpend((prevSeconds) => prevSeconds + 1);
        }
        let timeData = setInterval(() => tickTime(), 1000);

        return () => clearInterval(timeData);
    }, []);

    const handleNext = (formData, shouldEndSurvey = false, jumpToQuestion = null) => {
        // Save the current question data
        setQuestionArray([...questionArray, formData]);

        // Check if we should end the survey
        if (shouldEndSurvey) {
            saveQuestionData([...questionArray, formData], false);
            return;
        }

        // Check if we need to jump to a specific question
        if (jumpToQuestion) {
            // Find the index of the question to jump to
            const jump_index = QuestionArrayList.findIndex(q =>
                q.data.id === parseInt(jumpToQuestion)
            );

            if (jump_index !== -1) {
                setActiveQuestion(jump_index + 1);
                return;
            } else {
                // If we can't find the exact question, try to find by sort_order
                const sortOrderIndex = QuestionArrayList.findIndex(q =>
                    q.data.sort_order === parseInt(jumpToQuestion)
                );
                if (sortOrderIndex !== -1) {
                    setActiveQuestion(sortOrderIndex + 1);
                    return;
                }
            }
        }

        // Check if the current question has jump_to_question set to "End Survey"
        const currentQuestion = QuestionArrayList[isActiveQuestion - 1];
        if (currentQuestion?.data?.jump_to_question === "End Survey") {
            saveQuestionData([...questionArray, formData], false);
            return;
        }

        // Normal flow - move to next question
        if (isActiveQuestion < QuestionArrayList.length) {
            setActiveQuestion(isActiveQuestion + 1);
        } else {
            saveQuestionData([...questionArray, formData], false);
        }
    };

    const saveQuestionData = (formData, shouldNavigate) => {
        if (location.pathname.substr(1, 1) === "t") {
            let data = Object.assign({}, { questions: formData });
            data["test_id"] = result && result.test_id;
            data["result_id"] = result && result.id;
            data["question_type"] = questionType;
            data["guest_token"] = ReactSession.get("guest_token");
            data["time_spent"] = timeSpent;

            if (questionLoading) {
                return false;
            }

            if (!shouldNavigate) {
                setQuestionLoading(true);
            }

            if (shouldNavigate) {
                questionCallback(formData, questionType, false);
            }

            saveSurveyResultQuestion(data, ReactSession.get("token")).then(
                (response) => {
                    if (!shouldNavigate) {
                        setQuestionLoading(false);
                    }
                    if (response.success) {
                        callback();
                    } else {
                        showToast(response.message, "error");
                    }
                }
            );
        } else {
            callback();
        }
    };

    const taskHasError = () => {
        var error = false;
        if (QuestionArrayList.length == 0) {
            error = true;
        }
        return error;
    };

    return (
        <>
            {initialScreen && (
                <SurveyIntroduction
                    goToFirstTask={() => {
                        setInitialScreen(false);
                        setQuestionsScreen(true);
                        window.scrollTo(0, 0);
                    }}
                    testlanguage={test.language}
                />
            )}
            {questionsScreen && (
                <>
                    {taskHasError() ? (
                        <TaskNotCompleted
                            to={"/r/test/" + test.id + "/survey"}
                        />
                    ) : (
                        <div className="taking-test-page-wrap">
                            <div className="container">
                                {QuestionArrayList && QuestionArrayList.map((question, index) => (
                                    <div key={index}>
                                        {(isActiveQuestion === index + 1) && (
                                            <GlobalQuestion
                                                test={test}
                                                question={question}
                                                currentStep={isActiveQuestion}
                                                totalSteps={QuestionArrayList.length}
                                                onNext={handleNext}
                                                onSkip={() => {
                                                    if (isActiveQuestion < totalQuestion) {
                                                        setActiveQuestion(isActiveQuestion + 1);
                                                    } else {
                                                        saveQuestionData([...questionArray], false);
                                                    }
                                                }}
                                                isOptional={question.questionData.is_optional}
                                                timeSpent={timeSpent}
                                                questionType={questionType}
                                                result={result}
                                                questionCallback={questionCallback}
                                                callback={callback}
                                                methodology="survey"
                                                skippedCount={skippedCount}
                                                onSkipCountChange={setSkippedCount}
                                            />
                                        )}
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}
                </>
            )}
        </>
    );
}
